import _ from 'lodash';
import * as React from 'react';
import styled from 'styled-components';

const Content = styled.div`
	width: 100%;
`;
const LeftContent = styled.div`
	display: inline-block;
	vertical-align: top;
`;
LeftContent.displayName = 'LeftContent';

const RightContent = styled.div`
	display: inline-block;
	text-align: right;
	vertical-align: top;
`;
RightContent.displayName = 'RightContent';

export interface ICol10Col2Props {
	id?: string;
	leftContent: JSX.Element;
	rightContent: JSX.Element;
}

export class Col10Col2 extends React.Component<ICol10Col2Props> {
	public render() {
		const { id, leftContent, rightContent } = this.props;

		return (
			<Content className={'row'} id={id}>
				<LeftContent className='col-lg-10 col-sm-12'>{leftContent}</LeftContent>
				<RightContent className='col-lg-2 col-sm-12'>{rightContent}</RightContent>
			</Content>
		);
	}
}
